/* eslint-disable react/jsx-handler-names */
// Components
import Button from "components/atoms/Button";

// Hooks
import useTranslate from "hooks/useTranslate";
import { useBreakpoint } from "hooks/useBreakpoint";

import "./styles.sass";

type BannerItemProps = {
  image: string;
  content: string;
  title: string;
  buttonName: string;
  onClick: () => void;
};

const BannerItem = (props: BannerItemProps) => {
  const { image, title, content, buttonName, onClick } = props;
  const t = useTranslate();
  const { isCustomBreakpointSmaller } = useBreakpoint(1180);
  const handleButtonClick = (e) => {
    e.stopPropagation();
    onClick();
  };
  return (
    <div className="BannerItem" onClick={onClick}>
      <img className="BannerItem__img" src={image} alt="img" />
      <div className="BannerItem-text">
        <span className="BannerItem-text__title">{t(title)}</span>
        <span className="BannerItem-text__desc">{content}</span>
        {!isCustomBreakpointSmaller ? (
          <div className="BannerItem-text__btn">
            <Button label={buttonName} variation="primary" onClick={onClick} />
          </div>
        ) : (
          <span
            className="BannerItem__mob"
            onClick={(e) => handleButtonClick(e)}
          >
            {t(buttonName)}
          </span>
        )}
      </div>
    </div>
  );
};

export default BannerItem;
